import { render, staticRenderFns } from "./AppBigHelpMessage.vue?vue&type=template&id=30ddede8&scoped=true"
import script from "./AppBigHelpMessage.vue?vue&type=script&lang=js"
export * from "./AppBigHelpMessage.vue?vue&type=script&lang=js"
import style0 from "./AppBigHelpMessage.vue?vue&type=style&index=0&id=30ddede8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ddede8",
  null
  
)

export default component.exports